module.exports = __webpack_public_path__ + "img/yxlx-1.c8602a42.jpg";